/**
 * RGB を保持するクラス
 */
export class RGB {
  /**
   * 色コードから RGB オブジェクトを作成する
   *
   * @param {String} code #rrggbb 形式の色コード
   * @returns {RGB} RGB オブジェクトを返す
   */
  static fromCode (code) {
    if (typeof code !== 'string' || !code.startsWith('#')) {
      throw new Error(`TypeError: Cannot use code2Rgb(${code})`)
    }

    let r = 0; let g = 0; let b = 0
    if (code.length === 7) {
      // #rrggbb 形式
      r = parseInt(code.slice(1, 3), 16)
      g = parseInt(code.slice(3, 5), 16)
      b = parseInt(code.slice(5, 7), 16)
    } else {
      // #rgb 形式
      r = parseInt(code.slice(1, 2), 16)
      g = parseInt(code.slice(2, 3), 16)
      b = parseInt(code.slice(3, 4), 16)
      r += r * 16
      g += g * 16
      b += b * 16
    }

    return new RGB(r, g, b)
  }

  constructor (r = 0, g = 0, b = 0) {
    this.r = r
    this.g = g
    this.b = b
  }

  /**
   * 輝度を求める
   *
   * @return {number} 輝度(0.0〜1.0)を返す
   * @see [sRGB色空間と国際標準化](https://www.jstage.jst.go.jp/article/iieej/35/6/35_6_935/_pdf)
   */
  luminace () {
    let r, g, b

    // 0-255 を 0-1 に変換する
    r = this.r / 255.0
    g = this.g / 255.0
    b = this.b / 255.0

    // sRGB にデコードする
    r = (r < 0.003928) ? (r / 12.92) : (Math.pow((r + 0.055) / 1.055, 2.4))
    g = (g < 0.003928) ? (g / 12.92) : (Math.pow((g + 0.055) / 1.055, 2.4))
    b = (b < 0.003928) ? (b / 12.92) : (Math.pow((b + 0.055) / 1.055, 2.4))

    // 輝度を求める
    return 0.2126 * r + 0.7152 * g + 0.0722 * b
  }
}
